import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";

import commonStyle from "../../content/CommonStyles.module.css";

const TextInput = ({formik, paramName, value, label, isDisabled, customStyle="", setFunction, mandatory}) => {

    const field = formik ? formik?.getFieldProps(paramName) : null;

    const complexError = paramName?.includes(".");
    const errorName = complexError ? paramName.split(".")[1] : paramName;
    const touched = complexError ? formik?.touched[paramName.split(".")[0]] : formik?.touched[paramName];

    return (
        <div className={`${commonStyle.formInput} ${customStyle}`}>
            <div className="p-inputgroup flex-column">
                <FloatLabel>
                    <InputText value={value ?? field?.value}
                        onChange={(e) => { setFunction ? setFunction(e.target.value) : formik.setFieldValue(paramName, e.target.value) }}
                        disabled={isDisabled}
                        className={formik?.errors[errorName] && touched ? 'p-invalid w-full' : "w-full"} />
                    <label>{label}{mandatory && <span className={commonStyle.requiredAsterisk}>*</span>}</label>
                </FloatLabel>
                {formik?.errors[errorName] && touched && (<small className={commonStyle.errorSmall}>{formik?.errors[errorName]}</small>)}
            </div>
        </div>
    )
}

export default TextInput;